var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 88 88",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cube"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43,42.6036l-38-20V66a1,1,0,0,0,.5342.8848L43,86.6036Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,40.87l38-20L44.4658,1.1152a1.001,1.001,0,0,0-.9316,0L6,20.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45,42.6036v44L82.4658,66.8848A1.0008,1.0008,0,0,0,83,66V22.6037Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ed153882b3328ff02fc93a349cab36c8.svg";
export { ForwardRef as ReactComponent };